import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLearn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M14.4 12.636a.24.24 0 0 1-.4-.177V5.727L18 5v7.46a.24.24 0 0 1-.4.176l-1.398-1.906a.25.25 0 0 0-.404 0L14.4 12.636Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M2.25 5.017a1.75 1.75 0 0 1 2.157-1.702l7.535 1.802a.25.25 0 0 0 .116 0l7.535-1.802a1.75 1.75 0 0 1 2.157 1.702V16.65a1.75 1.75 0 0 1-1.218 1.667l-8 2.55a1.75 1.75 0 0 1-1.064 0l-8-2.55A1.75 1.75 0 0 1 2.25 16.65V5.017Zm1.808-.243a.25.25 0 0 0-.308.243V16.65c0 .109.07.205.174.238l8 2.55c.05.016.103.016.152 0l8-2.55a.25.25 0 0 0 .174-.238V5.017a.25.25 0 0 0-.308-.243l-7.535 1.802a1.75 1.75 0 0 1-.814 0L4.058 4.774Z"
    />
  </svg>
);
export default SvgTwoColorLearn;
